import HtmlElement from '../../../../Js/Elements/HtmlElement';
import { CountUp } from 'countup.js';

/**
 * Percentage
 */
const Percentage = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		INDICATOR: '.scarcity-percentage-bar-indicator',
		AVAILABILITY: '.scarcity-availability',
		AVAILABILITY_VALUE: '.scarcity-availability-value'
	};

	const DURATION = 6000;

	/**
	 * Percentage
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Percentage extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();
			this._$indicator = this.$element.find(Selector.INDICATOR);
			this._$availability = this.$element.parent(Selector.AVAILABILITY);
			this._$availabilityValue = this._$availability.find(Selector.AVAILABILITY_VALUE);
			this._initialize();
		}

		// Private

		_initialize() {
			const max = this.$element.data('max');
			const current = this.$element.data('current');

			const easingFn = (t, b, c, d) => {
				const ts = (t /= d) * t;
				const tc = ts * t;
				return b + c * (tc + -3 * ts + 3 * t);
			};

			const counter = new CountUp(this._$availabilityValue.get(0), current, {
				duration: DURATION / 1000 * 1.1,
				easingFn
			});

			if (!counter.error) {
				setTimeout(() => {
					counter.start();
					this._$indicator.css('transform', `scaleX(${current / max})`);

					setTimeout(() => {
						this._$availability.addClass('percentage-loaded');
					}, 5000);
				}, 500);
			} else {
				console.error(counter.error);
			}

			setTimeout(() => {
				this._$availability.addClass('percentage-loaded');
			}, DURATION);
		}
	}

	return Percentage;
})();

export default Percentage;
